<template>
  <div class="CoalStore_adjustHistory_box">
    <el-form :inline="true" :model="form" class="demo-form-inline" size="small">
      <el-form-item label="">
        <el-select
          v-model="form.coalWarehouseNo"
          placeholder="请输入仓号"
          filterable
          clearable
        >
          <el-option
            v-for="item in coalBunkerList"
            :key="item.id"
            :label="item.coalWarehouseNo"
            :value="item.coalWarehouseNo"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="form.dataPk" placeholder="煤种" filterable clearable>
          <el-option
            v-for="item in coalTypeList"
            :key="item.coalCategoryNo"
            :label="item.coalCategoryName"
            :value="item.coalCategoryNo"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select
          v-model="form.operationStaffName"
          placeholder="操作员"
          filterable
          clearable
        >
          <el-option
            v-for="item in operatorList"
            :key="item.staffId"
            :value="item.name"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          v-model="form.operationTime"
          type="datetimerange"
          range-separator="至"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="修改开始"
          end-placeholder="修改结束"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <kt-button
          icon="fa fa-search"
          label="搜索"
          perms="-1"
          @click="getData(true)"
          type="primary"
        />
      </el-form-item>
      <el-form-item>
        <kt-button
          icon="fa fa-share"
          label="重置"
          perms="-1"
          @click="getReset"
          type="primary"
        />
      </el-form-item>
    </el-form>
    <el-table
      v-loading="loading"
      :data="tableData"
      stripe
      size="mini"
      style="width: 100%"
    >
      <el-table-column type="index" label="序号" fixed width="120">
      </el-table-column>
      <el-table-column prop="coalWarehouseNo" label="仓号"> </el-table-column>
      <el-table-column prop="operationType" label="调整类型"> </el-table-column>
      <el-table-column prop="coalCategoryName" label="煤种"> </el-table-column>
      <el-table-column prop="operationTime" label="修改时间"> </el-table-column>
      <el-table-column prop="operationStaffName" label="操作员">
      </el-table-column>
      <el-table-column prop="operationRemark" label="备注"> </el-table-column>
      <el-table-column prop="operationResult" label="结果"> </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding: 20px">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float: right"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import KtButton from "@/components/Core/KtButton";

export default {
  components: {
    KtButton,
  },
  props: {
    coalMineNo: {
      type: [String],
      default: 100,
    },
  },
  data() {
    return {
      size: "small",
      loading: false,
      operationModule: 2,
      pageNo: 1,
      pageSize: 10,
      form: {
        dataPk: "", // 煤种
        operationStaffName: "", // 操作员
        operationTime: "",
      },
      coalTypeList: [],
      operatorList: [],
      // 表格数据
      tableData: [],
      totalSize: 0,
      coalBunkerList: [],
    };
  },
  mounted() {
    this.getData(true);
    this.getSelectByCoalMineNo();
    this.getSelect();
    this.getSelectMc();
  },
  methods: {
    getData(val) {
      const _t = this;
      if (val) {
        _t.pageNo = 1;
      }
      _t.loading = true;
      const params = {
        pageNo: _t.pageNo,
        pageSize: _t.pageSize,
        operationModule: _t.operationModule,
        coalMineNo: _t.coalMineNo,
      };
      const form = { ..._t.form };
      let index = 0;
      for (let key in form) {
        const val = form[key];
        if (val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "operationTime") {
            params["searchFieldList[" + index + "].rangeMinValue"] = val[0];
            params["searchFieldList[" + index + "].rangeMaxValue"] = val[1];
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      _t.$api.coalModel.getLogList(params).then((res) => {
        if (res.code === "0") {
          let resData = res.data.dtoList || [];
          resData.forEach((item) => {
            if (item.operationType === "1") {
              item.operationType = "新增";
            } else if (item.operationType === "2") {
              item.operationType = "修改";
            } else if (item.operationType === "3") {
              item.operationType = "删除";
            } else if (item.operationType === "4") {
              item.operationType = "审核";
            } else if (item.operationType === "5") {
              item.operationType = "导出";
            } else if (item.operationType === "6") {
              item.operationType = "停用";
            } else if (item.operationType === "7") {
              item.operationType = "启用";
            } else if (item.operationType === "8") {
              item.operationType = "调价";
            }
          });
          _t.tableData = resData;
          _t.totalSize = res.data.totalSize;
          _t.loading = false;
        } else {
          _t.loading = false;
          _t.$message({
            message: "查询失败, " + res.message,
            type: "error",
          });
        }
      });
    },
    // 获取所有煤仓下拉数据
    getSelectMc() {
      const _t = this;
      _t.$api.coalStore.getselectedList({coalMineNo: _t.coalMineNo}).then((res) => {
        if (res.code === "0") {
          _t.coalBunkerList = res.data;
        } else {
          _t.$message({
            message: "煤种下拉数据查询失败, " + res.message,
            type: "error",
          });
        }
      });
    },
    // 重置
    getReset() {
      const _t = this;
      _t.form.operationTime = "";
      _t.form.coalWarehouseNo = "";
      _t.form.dataPk = ""; // 煤种
      _t.form.operationStaffName = ""; // 操作员
      _t.getData(true);
    },
    getReturn() {
      const _t = this;
      _t.$emit("Adjust", false);
    },
    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getData(false);
    },
    // 根据煤矿编号查询操作人员
    getSelectByCoalMineNo() {
      const _t = this;
      _t.$api.coalModel.selectByCoalMineNo({coalMineNo: _t.coalMineNo}).then((res) => {
        if (res.code === "0") {
          _t.operatorList = res.data;
        }
      });
    },
    // 获取所有煤种下拉数据
    getSelect() {
      const _t = this;
      _t.$api.coalModel.getAllCoalCategories({coalMineNo: _t.coalMineNo}).then((res) => {
        if (res.code === "0") {
          _t.coalTypeList = res.data.coalCategoryList;
        } else {
          _t.$message({
            message: "煤种下拉数据查询失败, " + res.message,
            type: "error",
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.CoalStore_adjustHistory_box {
  .CoalStore_adjustHistory_box_title {
    padding: 10px;

    span:first-child {
      font-weight: 700;
      font-size: 32px;
      padding-right: 10px;
      cursor: pointer;
      vertical-align: middle;
    }

    span:last-child {
      font-weight: 700;
      font-size: 20px;
      vertical-align: middle;
    }
  }
}
</style>
